import { render, staticRenderFns } from "./Wizardot4draw.vue?vue&type=template&id=994d1f7c&scoped=true&"
import script from "./Wizardot4draw.vue?vue&type=script&lang=js&"
export * from "./Wizardot4draw.vue?vue&type=script&lang=js&"
import style0 from "./Wizardot4draw.vue?vue&type=style&index=0&id=994d1f7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "994d1f7c",
  null
  
)

export default component.exports